import { render, staticRenderFns } from "./DetailsFeatures.vue?vue&type=template&id=0a6f9452&scoped=true&"
import script from "./DetailsFeatures.vue?vue&type=script&lang=js&"
export * from "./DetailsFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFeatures.vue?vue&type=style&index=0&id=0a6f9452&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f9452",
  null
  
)

export default component.exports